import RequestProcessed from './RequestProcessed';

export default RequestProcessed;
